var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-form',{staticClass:"pb-5",attrs:{"no-bezel":""},scopedSlots:_vm._u([{key:"top-right",fn:function(){return [_c('kst-button',{staticClass:"is-primary",attrs:{"action-mode":"","full-label":"","module":_vm.Model.Module,"moduleType":_vm.Model.ModuleType.New}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }